import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import useMutationDeleteProfilePageBanner from '@/modules/client-setting/api/hooks/useMutationDeleteProfilePageBanner'
import { ProfilePageBannerQueryKeys } from '@/modules/client-setting/keys'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { Button } from '@/common/ui/button'
import { ProfilePageBannerData } from '@/modules/client-setting/type'

interface DeleteProfilePageBannerProps {
	data: ProfilePageBannerData
}

export default function DeleteProfilePageBanner({
	data,
}: DeleteProfilePageBannerProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteProfilePageBanner } =
		useMutationDeleteProfilePageBanner({
			onSuccess: () => {
				toast.success('ลบปุ่มทางเข้าเกมสำเร็จ')
				queryClient.invalidateQueries({
					queryKey: [ProfilePageBannerQueryKeys.GetProfilePageBanners],
				})
			},
			onError: (error) => {
				showErrorToast(error)
			},
		})

	const handleDelete = () => {
		deleteProfilePageBanner({ id: data.id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive hover:text-destructive/80" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบปุ่มทางเข้าเกม</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบปุ่ม &quot;{data.title}&quot; หรือไม่?
						<br />
						การกระทำนี้ไม่สามารถย้อนกลับได้
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ลบ</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
